import Swiper from 'swiper'
import { Autoplay, Controller, EffectFade } from 'swiper/modules'

import * as breakpoints from '@js/util/breakpoints'
import { select } from '@js/util/select'

let controllerSwiperBreakpoint = 'sm'

select('.wpce-news-hero', swiperElement => {
  let controllerSwiperElement = swiperElement.querySelector('.news-box-items')

  // The background image swiper
  // Autoplays and fades between slides, but is not user-controllable
  let swiper = new Swiper(`#${swiperElement.dataset.swiperId}`, {
    allowTouchMove: false,
    modules: [Autoplay, EffectFade],
    loop: false,
    effect: 'fade',
    autoplay: {
      delay: (parseFloat(swiperElement.dataset.duration) || 6) * 1000,
    },
    pagination: false,
    keyboard: false,
    speed: 600,
  })

  let controllerSwiper

  Alpine.store('initialized').then(() => {
    // Set swiper on Alpine data
    let $data = Alpine.evaluate(swiperElement, '$data')
    $data.swiper = swiper

    // While autoplay is active, adjust controller swiper to reflect background swiper
    swiper.on('autoplay', () => {
      controllerSwiper?.slideTo(swiper.realIndex)
    })

    // Set progress bar on Alpine data
    swiper.on('autoplayTimeLeft', (swiper, remaining, progress) => {
      requestAnimationFrame(() => {
        $data.progress = 1 - progress
      })
    })

    // When autoplay stops, remove progress bar
    swiper.on('autoplayStop', () => {
      requestAnimationFrame(() => {
        $data.progress = null
      })
    })

    // When background swiper changes slides, reflect that in Alpine
    swiper.on('slideChange', () => {
      setTimeout(() => {
        $data.index = swiper.realIndex
      }, 0)
    })

    // Create the controller swiper
    function createControllerSwiper() {
      if (controllerSwiper) return

      controllerSwiper = new Swiper(controllerSwiperElement, {
        modules: [Controller, Autoplay],
        allowTouchMove: true,
        touchReleaseOnEdges: true,
        slidesPerView: 'auto',
        speed: 600,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
          0: {
            spaceBetween: 16,
          },
          540: {
            spaceBetween: 24,
          },
        },
      })

      // When the controller swiper is first used,
      // stop autoplay and make it control the background swiper
      controllerSwiper.on('sliderFirstMove', () => {
        swiper.autoplay.stop()
        controllerSwiper.controller.control = swiper
      })

      $data.controllerSwiper = controllerSwiper
      $data.controlled = true
    }

    // Destroy the controller swiper
    function destroyControllerSwiper() {
      if (!controllerSwiper) return

      $data.controlled = false
      $data.controllerSwiper = undefined

      controllerSwiper.destroy()
      controllerSwiper = undefined
    }

    // Make the controller swiper available for as long as screen is below certain breakpoint
    if (!breakpoints.doesMatch(controllerSwiperBreakpoint)) {
      createControllerSwiper()
    }
    breakpoints.watch(controllerSwiperBreakpoint, matches => {
      if (!matches) {
        createControllerSwiper()
      } else {
        destroyControllerSwiper()
      }
    })
  })

  // Cleanup
  return () => {
    swiper.destroy()
    controllerSwiper?.destroy()
  }
})
